<template>

<section class="promo pt-5 pb-5">
    <div class="container mb-4">
        <div class="row mb-4">
            <div class="col-12">
                <h2 class="text-center">
                    <span class="stars text-gold">
                        <span class="icon icon-star icon-1"></span>
                        <span class="icon icon-star icon-2"></span>
                        <span class="icon icon-star icon-3"></span>
                    </span>
                    
                    Free onlyfans content, worth over
                    <span class="text-main accent">
                        &dollar; 500 000
                    </span>
                </h2>
            </div>
        </div>

        <div class="row d-flex justify-content-center">
            <!-- Plan Start -->
            <div class="col-xl-4 col-lg-5 col-md-6 col-sm-8">                   
                <div class="card card-plan h-100 main-plan">
                    <div class="card-header">
                        <h5 class="text-gold text-uppercase mb-0">
                            90% Discount
                        </h5>
                        <span class="text-muted">
                            6 months Subscrition Plan
                        </span>
                    </div>

                    <div class="card-body d-flex justify-content-end flex-column align-items-center">
                        <!-- If old price this container: -->
                        <div class="old-price">
                            <s>&dollar; 49,00</s>
                        </div>
                        <!-- Endif -->

                        <!-- Main Price: -->
                        <div class="price">
                            <div class="d-flex align-items-center">
                                <span class="dollar mr-1">
                                    &dollar;
                                </span>
                                <span class="num">
                                    4.99
                                </span>
                            </div>
                            <span class="text-muted">
                                /monthly
                            </span>
                        </div>
                        <!-- End Main Price -->

                        <!-- Button -->
                        <a :href="user ? '/aregs/3' : '/register#3'" class="btn btn-primary mt-4">
                            Buy now
                        </a>
                        <!-- End Button -->
                    </div>                      
                </div>                  
            </div>
            <!-- Plan End -->
        </div>   

        <div class="row mt-4">
            <div class="col-12 text-center">
                <h2>
                    <span class="small-h2 d-block mb-0 mb-md-2">
                        Pay a single subscription to unlock all content!
                        New Content Uploaded Daily!
                    </span>
                </h2>
                <p>
                    In OFMDB you’ll find the latest content of trending models such as Belle Delphine. <br> 
                    You pay for a single package and get content that you’ll have to pay in every each onlyfans profile.
                </p>
            </div>
        </div>

    </div>
</section>


</template>

<script>
    export default {

        mounted() {

        },

        created() {
           
        },

        data() {
            return {
                isReady : false,
            }
        },

        methods : {

        }

    }
</script>
